module.exports = __webpack_public_path__ + "img/61.e2c22e67.png";